import { useState } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { Dialog, DialogContent, DialogTitle } from "../ui/dialog";
import { imageUrl } from "../../lib/api";
import { PHOTO_PHASES } from "../../data/portfolio";

const tab = (on) => `rounded-full px-3.5 py-1.5 text-[13.5px] font-semibold transition-colors ${on ? "bg-ink text-white" : "bg-white text-slate-600 ring-1 ring-slate-200 hover:text-ink"}`;
const phaseLabel = (id) => PHOTO_PHASES.find((x) => x.id === id)?.label || "";

export const ProjectGallery = ({ p }) => {
  const photos = p.gallery || [];
  const phases = PHOTO_PHASES.filter((ph) => photos.some((g) => g.phase === ph.id));
  const [phase, setPhase] = useState("");
  const [idx, setIdx] = useState(null);
  if (!photos.length) return null;
  const shown = photos.filter((g) => !phase || g.phase === phase);
  const cur = idx !== null ? shown[idx] : null;
  const go = (d) => setIdx((i) => (i + d + shown.length) % shown.length);
  return (
    <section aria-labelledby="fotos-title" className="section-tight" data-testid="project-gallery">
      <div className="container-tight">
        <h2 id="fotos-title" className="h2">Foto's van dit project</h2>
        {phases.length > 1 && (
          <div className="mt-5 flex flex-wrap gap-2" role="group" aria-label="Fotofase">
            <button type="button" className={tab(!phase)} onClick={() => setPhase("")} data-testid="gallery-phase-all">Alle foto's</button>
            {phases.map((ph) => <button key={ph.id} type="button" className={tab(phase === ph.id)} onClick={() => setPhase(ph.id)} data-testid={`gallery-phase-${ph.id}`}>{ph.label}</button>)}
          </div>
        )}
        <ul className="mt-6 grid grid-cols-2 gap-3 md:grid-cols-3 lg:grid-cols-4">
          {shown.map((g, i) => (
            <li key={g.path}>
              <button type="button" onClick={() => setIdx(i)} className="group relative block aspect-square w-full overflow-hidden rounded-xl bg-slate-100" data-testid={`gallery-photo-${i}`}>
                <img src={imageUrl(g.path)} alt={g.alt || p.title} loading="lazy" className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" />
                {g.phase && <span className="absolute bottom-2 left-2 rounded-md bg-white/90 px-2 py-0.5 text-[11px] font-medium text-slate-700">{phaseLabel(g.phase)}</span>}
              </button>
            </li>
          ))}
        </ul>
      </div>
      <Dialog open={!!cur} onOpenChange={(o) => !o && setIdx(null)}>
        {cur && (
          <DialogContent className="max-w-5xl border-0 bg-ink p-3 sm:rounded-2xl" data-testid="gallery-lightbox">
            <DialogTitle className="sr-only">{cur.alt || p.title}</DialogTitle>
            <img src={imageUrl(cur.path)} alt={cur.alt || p.title} className="max-h-[78vh] w-full rounded-xl object-contain" />
            <div className="flex items-center justify-between gap-3 px-1 pt-2 text-[14px] text-slate-200">
              <button type="button" onClick={() => go(-1)} className="inline-flex h-10 w-10 items-center justify-center rounded-full bg-white/10 hover:bg-white/20" aria-label="Vorige foto"><ChevronLeft className="h-5 w-5" /></button>
              <span>{[phaseLabel(cur.phase), cur.alt].filter(Boolean).join(" · ")} ({idx + 1}/{shown.length})</span>
              <button type="button" onClick={() => go(1)} className="inline-flex h-10 w-10 items-center justify-center rounded-full bg-white/10 hover:bg-white/20" aria-label="Volgende foto"><ChevronRight className="h-5 w-5" /></button>
            </div>
          </DialogContent>
        )}
      </Dialog>
    </section>
  );
};
